import type { CSSProperties } from "react";
import { resolveAssetPath } from "../../shared/utilities/assets";
import type { SectionRenderProps } from "../renderer/types";

function displayEventDates(data: SectionRenderProps["data"]) {
  const labels = data.events
    .slice()
    .sort((a, b) => a.order - b.order)
    .map((event) => event.date ? new Intl.DateTimeFormat(data.project.language === "id" ? "id-ID" : data.project.language === "zh" ? "zh-TW" : "en-US", { day: "numeric", month: "long", year: "numeric", timeZone: event.timezone }).format(new Date(`${event.date}T12:00:00Z`)) : "")
    .filter(Boolean);
  return Array.from(new Set(labels)).join(" & ");
}

export function CoverSection({ data, config, copy, invitationOpen, onOpenInvitation }: SectionRenderProps) {
  const cover = resolveAssetPath(data.invitation.coverImage);
  const coverVideo = resolveAssetPath(data.invitation.coverVideo || "");
  const hero = resolveAssetPath(String(config.settings.heroImage || data.invitation.coverImage));
  const mobileHero = resolveAssetPath(String(config.settings.mobileHeroImage || config.settings.heroImage || data.invitation.coverImage));
  const heroVideo = resolveAssetPath(String(config.settings.heroVideo || ""));
  const mobileHeroVideo = resolveAssetPath(String(config.settings.mobileHeroVideo || ""));
  const dateLabel = displayEventDates(data);
  const backgroundStyle = { "--photo": `url("${cover}")` } as CSSProperties;
  const heroStyle = { "--photo": `url("${hero}")` } as CSSProperties;

  return (
    <>
      <div className={`cover ${invitationOpen ? "is-open" : ""}`} style={backgroundStyle} data-editor-section="cover" data-editor-field="invitation.coverImage">
        <img src={cover} alt={data.invitation.title} className="cover-photo" />
        {coverVideo ? <video className="cover-photo background-video" key={coverVideo} poster={cover} autoPlay muted loop playsInline preload="auto" aria-hidden="true"><source src={coverVideo} /></video> : null}
        <div className="cover-shade" />
        <div className="cover-content">
          <p className="eyebrow" data-editor-section="cover" data-editor-field="invitation.subtitle">{data.invitation.subtitle}</p>
          <p className="guest-line" data-editor-section="cover" data-editor-field="invitation.guestName">{copy.dear} {data.invitation.guestName}</p>
          <h1 data-editor-section="cover" data-editor-field="invitation.title">{data.invitation.title}</h1>
          <p className="cover-date">{dateLabel}</p>
          <button className="primary-btn" type="button" onClick={onOpenInvitation} data-editor-section="cover" data-editor-field="invitation.openButtonText">{data.invitation.openButtonText}</button>
        </div>
      </div>
      <header className="hero" id="home" style={heroStyle}>
        <picture>
          <source media="(max-width: 720px)" srcSet={mobileHero} />
          <img src={hero} alt={data.invitation.title} className="hero-photo" />
        </picture>
        {heroVideo || mobileHeroVideo ? <video className="hero-photo background-video" key={`${heroVideo}:${mobileHeroVideo}`} poster={hero} autoPlay muted loop playsInline preload="auto" aria-hidden="true">{mobileHeroVideo ? <source media="(max-width: 720px)" src={mobileHeroVideo} /> : null}{heroVideo ? <source src={heroVideo} /> : null}</video> : null}
        <div className="hero-overlay" />
        <section className="hero-copy">
          <p className="eyebrow">{copy.weddingOf}</p>
          <h1><span data-editor-section="couple" data-editor-field="couple.groom.displayName">{data.couple.groom.displayName}</span><br /><span>&</span><br /><span data-editor-section="couple" data-editor-field="couple.bride.displayName">{data.couple.bride.displayName}</span></h1>
          <p className="hero-line">{dateLabel}</p>
          <div className="hero-actions">
            <a className="primary-btn" href="#events">{copy.details}</a>
            {data.rsvp.enabled ? <a className="ghost-btn" href="#rsvp">{copy.reservation}</a> : null}
            {data.events[0]?.mapsUrl ? <a className="ghost-btn" href={data.events[0].mapsUrl} target="_blank" rel="noreferrer">{copy.maps}</a> : null}
          </div>
        </section>
      </header>
    </>
  );
}
